// 基础
import Vue from 'vue'
import Router from 'vue-router'

import home from '../view/tabBar/home/index'
import whyd from '../view/tabBar/whyd/index'
import hpyx from '../view/tabBar/hpyx/index'
import me from '../view/tabBar/me/index'

// 路由文件
import unionJS from './union'
import whydJS from './whyd'
import commonJS from "./common"
import meJS from "./me"
import userJS from "./user"

const error = resolve => require(['../view/common/error'], resolve)

Vue.use(Router)

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}



let routes = [
  {
    path: '/',
    name: 'home',
    component: home,
    meta: {
    }
  },{
    path: '/whyd',
    name: 'whyd',
    component: whyd,
    meta: {
    }
  },{
    path: '/hpyx',
    name: 'hpyx',
    component: hpyx,
    meta: {
    }
  },{
    path: '/me',
    name: 'me',
    component: me,
    meta: {
    }
  },
  // ...Login.routes,
  // ...Benefit.routes,
  // ...third.routes,
  // ...my.routes,
  ...commonJS.routes,
  ...unionJS.routes,
  ...whydJS.routes,
  ...meJS.routes,
  ...userJS.routes,
  {
    path: '*',
    component: error,
    children: [
      {
        path: '*', component: error
      }
    ]
  }
]
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes,
  // 切换路由后滚动条置顶
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  }
})
export default router
router.beforeEach((to, from, next) => {
  if (to.query.clearMsg) {
    localStorage.clear()
  }
  next()
})



// WEBPACK FOOTER //
// ./src/router/index.js